<template>
  <div class="lineup__info__wrapper">
    <div
      :class="[
        'indicator',
        {
          active:
            current_match.ls === 1 && current_match.lineups_generated === 2,
        },
      ]"
      v-if="current_match && current_match.status === 1"
    >
      <p class="txt">
        {{ this.getLineupStatusText(current_match) }}
      </p>
    </div>
    <div class="lineup-form-wrap">
      <form action class="lineup-form">
        <div class="form-element mobile-config-sel">
          <div class="form-group platform-selection">
            <select-list
              v-if="lineup_selection.p_id"
              id="platform_selection_dd"
              :options="pf_dropdowns"
              :selected="lineup_selection.p_id"
              :label="'pname'"
              :onSelect="onPlatformSelect"
              :identifier="'pid'"
            />
          </div>
          <div class="form-group strategy-selection">
            <select-list
              v-if="!isNaN(lineup_selection.s_id)"
              id="strategy_selection_dd"
              :options="stg_dropdown[lineup_selection.p_id] || []"
              :selected="lineup_selection.s_id"
              :label="'name'"
              :identifier="'sid'"
              :onSelect="onStrategySelect"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="user-note">
      <strong>Disclaimer : </strong> 
      <span>Please don’t copy the team, this team is based on analysis, understanding and past performance. Make your own decision, considering player score, rating and form mentioned.</span>
    </div>
    <gamezy-ad size="mob_small" ad_id="mob_small-ad-1" :autoDetect="true" />
    <gamezy-ad size="web_small" ad_id="web_small-ad-1" :autoDetect="true" />
    <div class="budget-wrap">
      <span>
        {{ translations.budget }} -
        <span class="budget">{{ lineup_details.ub }}</span>
      </span>
      <div class="autocomplete">
        <button
          :class="[
            'btn-autocomplete',
            locked_players.length || out_players.length ? '' : 'btn-disabled',
          ]"
          @click="
            locked_players.length || out_players.length
              ? autoCompleteLineup()
              : (e) => !1
          "
        >
          {{ translations.autocomplete }}
        </button>
      </div>
    </div>
    <div class="lineup-match-info">
      <ul class="tab-modes">
        <li
          :class="[tab_view === 'pitch' ? 'active' : '']"
          @click="toggleTab('pitch')"
        >
          {{ translations.viewTeamTab }}
        </li>
        <li
          :class="[tab_view === 'list' ? 'active' : '']"
          @click="toggleTab('list')"
        >
          {{ translations.editTeamTab }}
        </li>
      </ul>

      <pitch-view
        :stg_list="stg_dropdown[lineup_selection.p_id] || []"
        :team="lineup_details.team"
        :team_id="selected_team.id"
        :selected_strategy="lineup_selection.s_id"
        :onChange="onStrategySelect"
        :platform="pf_dropdowns.find((pf) => pf.pid === lineup_selection.p_id)"
        :has_players_selected="out_players.length || locked_players.length"
        :current_match="current_match"
        v-if="tab_view === 'pitch'"
        :togglePlayerPopup="this.togglePlayerPopup"
        :printSkillName="printSkillName"
        :isFootball="current_sport === 2"
      />
      <!-- pitch view  component -->

      <div class="match-info-list" v-if="tab_view === 'list'">
        <edit-team-view
          :current_match="current_match"
          :rating_tool_tip="rating_tool_tip"
          :xf_tool_tip="xf_tool_tip"
          :lock_tool_tip="lock_tool_tip"
          :closeToolTipExcept="closeToolTipExcept"
          :teamList="lineup_details.team"
          :printSkillName="printSkillName"
          :trending_tool_tip="trending_tool_tip"
          :addToTrending="addToTrending"
          :onOpenPlayerPopup="onOpenPlayerPopup"
          :ratingDisplayVal="ratingDisplayVal"
          :locked_players="locked_players"
          :out_players="out_players"
          :lockPlayer="lockPlayer"
        />
        <gamezy-ad size="mob_small" ad_id="mob_small-ad-2" :autoDetect="true" />
        <gamezy-ad size="web_small" ad_id="web_small-ad-2" :autoDetect="true" />
        <edit-team-view
          v-if="lineup_details.bench && lineup_details.bench.length"
          :current_match="current_match"
          :heading="translations.bench_p_label"
          clsName="bench-players"
          :rating_tool_tip="rating_tool_tip"
          :xf_tool_tip="xf_tool_tip"
          :lock_tool_tip="lock_tool_tip"
          :closeToolTipExcept="closeToolTipExcept"
          :teamList="lineup_details.bench"
          :printSkillName="printSkillName"
          :trending_tool_tip="trending_tool_tip"
          :addToTrending="addToTrending"
          :onOpenPlayerPopup="onOpenPlayerPopup"
          :ratingDisplayVal="ratingDisplayVal"
          :locked_players="locked_players"
          :out_players="out_players"
          :lockPlayer="lockPlayer"
        />
        <edit-team-view
          v-if="lineup_details.excluded && lineup_details.excluded.length"
          :current_match="current_match"
          :heading="translations.out_p_label"
          clsName="excluded-players"
          :rating_tool_tip="rating_tool_tip"
          :xf_tool_tip="xf_tool_tip"
          :lock_tool_tip="lock_tool_tip"
          :closeToolTipExcept="closeToolTipExcept"
          :teamList="lineup_details.excluded"
          :printSkillName="printSkillName"
          :trending_tool_tip="trending_tool_tip"
          :addToTrending="addToTrending"
          :onOpenPlayerPopup="onOpenPlayerPopup"
          :ratingDisplayVal="ratingDisplayVal"
          :locked_players="locked_players"
          :out_players="out_players"
          :lockPlayer="lockPlayer"
        />
      </div>
    </div>
    <recommended-contests
      v-if="current_match.status == 1"
      :current_match="current_match"
    />
    <div
      class="toast-wrap"
      v-if="top_fantasy_xi_error.status"
      @click="closeToast"
    >
      <div class="toast-container">
        <div class="toast-content">
          <div class="toast-msg">
            <p class="toast-text">{{ top_fantasy_xi_error.msg }}</p>
          </div>
        </div>
      </div>
    </div>
    <loader text="Loading lineup" v-if="show_loader" />
  </div>
</template>
<script>
import "vue-select/dist/vue-select.css";
import SelectList from "../../common/SelectList";
import "../../../assets/js/directives/VClose";
import "../../../assets/js/directives/VFill";
import {
  CFG_TRACKING,
  SPORTS_SKILLS,
  CFG_CHECK_FOR_LOGIN_COOKIE,
} from "../../../assets/js/config";
import {
  getMatch,
  addPagePropertiesToObject,
  sendTrackingData,
  deepClone,
  getCookieValue,
} from "../../../assets/js/common";
import PitchViewSlider from "./PitchViewSlider";
import EditTeamView from "./EditTeamView";
import RecommendedContests from "./RecommendedContests";
import Loader from "../../common/Loader";
import GamezyAd from '../../common/GamezyAd';
export default {
  props: ["togglePlayerPopup"],
  components: {
    SelectList,
    Loader,
    "pitch-view": PitchViewSlider,
    EditTeamView,
    RecommendedContests,
    GamezyAd
  },
  data() {
    return {
      lock_tool_tip: {
        recommended_11: false,
        bench: false,
        excluded: false,
      },
      rating_tool_tip: {
        recommended_11: false,
        bench: false,
        excluded: false,
      },
      xf_tool_tip: {
        recommended_11: false,
        bench: false,
        excluded: false,
      },
      is_scrolled_till: {
        bench_players: false,
        excluded_players: false,
      },
      trending_tool_tip: {},
      check_scroll_for: [".excluded-players", ".bench-players"],
      tab_view: "pitch",
      show_loader: false,
      anonymousViewTeamLimit: 2,
      anonymousViewTeamCount: 0,
    };
  },
  created() {
    typeof window !== "undefined" &&
      document.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug() {
      return this.$store.state.match_detail_store.slug;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug) || {};
    },
    current_sport() {
      return this.$store.state.match_detail_store.current_sport;
    },
    translations() {
      return this.$store.state.translations;
    },
    /**shared state end */
    lineup_details: {
      get() {
        return this.$store.state.team_store.lineup_details;
      },
    },
    lineup_selection: {
      get: function () {
        return this.$store.state.team_store.lineup_selection;
      },
      set: function (val) {
        this.$store.state.team_store.lineup_selection = val;
      },
    },
    locked_players: {
      get: function () {
        return this.$store.state.team_store.locked_players;
      },
      set: function (val) {
        this.$store.state.team_store.locked_players = val;
      },
    },
    out_players: {
      get: function () {
        return this.$store.state.team_store.out_players;
      },
      set: function (val) {
        this.$store.state.team_store.out_players = val;
      },
    },
    pf_dropdowns() {
      return this.$store.state.team_store.pf_dropdowns;
    },
    stg_dropdown: {
      get() {
        return this.$store.state.team_store.stg_dropdown;
      },
      set(val) {
        this.$store.state.team_store.stg_dropdown = val;
      },
    },
    selected_team: {
      get: function () {
        return this.$store.state.team_store.selected_team;
      },
      set: function (val) {
        this.$store.state.team_store.selected_team = val;
      },
    },
    can_show_players_changed: {
      get() {
        return this.$store.state.team_store.can_show_players_changed;
      },
      set(val) {
        this.$store.state.team_store.can_show_players_changed = val;
      },
    },
    can_show_undo: {
      get() {
        return this.$store.state.team_store.can_show_undo;
      },
      set(val) {
        this.$store.state.team_store.can_show_undo = val;
      },
    },
    top_fantasy_xi_error: {
      get() {
        return this.$store.state.team_store.top_fantasy_xi_error;
      },
      set(val) {
        this.$store.state.team_store.top_fantasy_xi_error = val;
      },
    },
    error_status() {
      return this.$store.state.team_store.top_fantasy_xi_error.status;
    },
    custom_team_base_sid: {
      get() {
        return this.$store.state.team_store.custom_team_base_sid;
      },
      set(val) {
        this.$store.state.team_store.custom_team_base_sid = val;
      },
    },
  },
  methods: {
    printSkillName(s_id, keyName) {
      let skillsObj = SPORTS_SKILLS[this.current_sport][s_id];
      return skillsObj[keyName] || skillsObj.name;
    },
    onOpenPlayerPopup(player) {
      this.togglePlayerPopup && this.togglePlayerPopup(player);
    },
    getLineupStatusText(match) {
      let transObj = this.translations;
      if (match.m) {
        // m is added from admin in some conditions like toss delayed, etc.
        return match.m;
      } else if (match.m1 && match.m1.length) {
        // m1 will be available when there is a match in progress before current match toss will happen
        let { event_name, teams } = match.m1[0],
          transText = transObj.ongoing_match_lineup_text;
        if (teams && teams.length > 1) {
          let matchName = `${teams[0].short_name} ${transObj.vs_label} ${teams[1].short_name}`;
          transText = transText.replace("{{matchName}}", matchName);
        } else {
          transText = transText.replace("{{matchName}}", "");
        }

        if (event_name) {
          return transText.replace("{{match}}", `${event_name} : `);
        } else {
          return transText.replace("{{match}}", "");
        }
      } else {
        if (match.ls === 1 && match.lineups_generated === 2) {
          return transObj.post_lineup_text;
        } else {
          if (match.sport_id === 2) {
            return transObj.pre_lineup_text_2;
          } else {
            return transObj.pre_lineup_text;
          }
        }
      }
    },
    checkIfLoggedIn() {
      if (typeof window === "undefined") return;
      try {
        return JSON.parse(getCookieValue(CFG_CHECK_FOR_LOGIN_COOKIE)) || false;
      } catch (e) {
        return false;
      }
    },
    onStrategySelect(val, isSwipe) {
      /**
       * on strategy id  from dropdown change event
       * get strategy object from state 'stg_dropdown' for current pf
       * set strategy id  lineup_selection
       * select first team
       */
      // open login popup here
      if (+val !== 1) {
        // FG Best 11 team view doesn't count
        this.anonymousViewTeamCount = this.anonymousViewTeamCount + 1;
      }
      if (this.anonymousViewTeamCount > this.anonymousViewTeamLimit) {
        let loggedin = this.checkIfLoggedIn();
        if (!loggedin) {
          let templateLoginBtn = document.querySelector(".user-img.icon-login");
          if (templateLoginBtn && templateLoginBtn.click) {
            let toTrack = deepClone(CFG_TRACKING["8"]);
            toTrack.action = "trigger";
            toTrack.category = "login_popup";
            toTrack.label = "force-login";
            toTrack.value = "yes";
            toTrack = addPagePropertiesToObject(toTrack);
            sendTrackingData(toTrack);
            templateLoginBtn.click();
          }
        }
      }

      this.removeCustomStrategyOption();
      let lineup_selection = this.lineup_selection;
      let selected_team = this.selected_team;
      lineup_selection.s_id = +val;

      let strategy = this.stg_dropdown[lineup_selection.p_id].find(
        (s) => +s.sid === +val
      );
      selected_team.id = strategy.teams.find((e) => true);
      selected_team.index = 0;

      this.lineup_selection = lineup_selection;
      this.selected_team = selected_team;
      this.locked_players = [];
      this.out_players = [];
      this.$store.dispatch("team_store/resetLineup");
      this.$store.dispatch("team_store/fetchLineup");
      this.$store.dispatch("team_store/fetchRecommendedContests", {
        slug: this.slug,
      });
      let toTrack = CFG_TRACKING["8"];
      if (isSwipe) toTrack.action = "swipe";
      toTrack.value = val;
      toTrack.label = strategy.name;
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
    onPlatformSelect(val) {
      /**
       * on pf guid id from dropdown change event
       * get strategy object from state 'stg_dropdown' for current pf
       * set strategy id  lineup_selection
       * select first team
       */
      this.removeCustomStrategyOption();
      let lineup_selection = this.lineup_selection;
      let selected_team = this.selected_team;
      lineup_selection.p_id = val;
      let first_stg = this.stg_dropdown[val].find((e) => true);
      lineup_selection.s_id = first_stg.sid;

      selected_team.id = first_stg.teams.find((e) => true);
      selected_team.index = 0;

      this.lineup_selection = lineup_selection;
      this.selected_team = selected_team;
      this.locked_players = [];
      this.out_players = [];
      this.$store.dispatch("team_store/resetLineup");
      this.$store.dispatch("team_store/fetchLineup");
      this.$store.dispatch("team_store/fetchRecommendedContests", {
        slug: this.slug,
      });

      let toTrack = CFG_TRACKING["7"];
      toTrack.value = val;
      toTrack.label = this.pf_dropdowns.find((pf) => pf.pid === val).pname;
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
    lockPlayer(type, id) {
      //condition added if current match is expired one
      if (this.current_match.status !== 1) return false;
      let toTrack;
      function fnrm(arr, id) {
        let i = arr.indexOf(+id);
        if (i !== -1) {
          arr.splice(i, 1);
        }
      }

      let in_squad_p = [...this.locked_players];
      let out_squad_p = [...this.out_players];
      switch (type) {
        case "in":
          fnrm(out_squad_p, id);
          if (in_squad_p.includes(id)) {
            let index = in_squad_p.findIndex((i) => i === id);
            in_squad_p.splice(index, 1);
          } else {
            in_squad_p.push(id);
            toTrack = CFG_TRACKING["10"];
            toTrack.value = id;
          }
          break;
        case "out":
          fnrm(in_squad_p, id);
          if (out_squad_p.includes(id)) {
            let index = out_squad_p.findIndex((i) => i === id);
            out_squad_p.splice(index, 1);
          } else {
            out_squad_p.push(id);
            toTrack = CFG_TRACKING["11"];
            toTrack.value = id;
          }
          break;
      }
      this.locked_players = in_squad_p.sort();
      this.out_players = out_squad_p.sort();
      if (toTrack) {
        toTrack = addPagePropertiesToObject(toTrack);
        sendTrackingData(toTrack);
      }
    },
    autoCompleteLineup() {
      this.can_show_undo = true;
      this.can_show_players_changed = true;

      this.addCustomStrategyOption();

      this.$store.dispatch("team_store/fetchLineup");

      let toTrack = CFG_TRACKING["9"];
      toTrack.label = "Get New 11";
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
    closeToolTip(section) {
      this.lock_tool_tip = {
        recommended_11: false,
        bench: false,
        excluded: false,
      };
      this.rating_tool_tip = {
        recommended_11: false,
        bench: false,
        excluded: false,
      };
      this.xf_tool_tip = {
        recommended_11: false,
        bench: false,
        excluded: false,
      };
    },
    closeToolTipExcept(section, prop) {
      let default_state = {
        recommended_11: false,
        bench: false,
        excluded: false,
      };
      this.lock_tool_tip = deepClone(default_state);
      this.xf_tool_tip = deepClone(default_state);
      this.rating_tool_tip = deepClone(default_state);
      if (section && prop) this[section][prop] = !this[section][prop];
    },
    closeToast() {
      this.top_fantasy_xi_error = {
        status: false,
        msg: "",
      };
    },
    addToTrending(id) {
      this.trending_tool_tip = {};
      this.trending_tool_tip[id] = true;
    },
    /**
     * for analytics
     */
    elementInViewport(el) {
      /**extra 100 for bench first player row */
      let top = el.offsetTop + 100;
      let height = el.offsetHeight;
      let bottom = top + height;

      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
      }

      return (
        !(top < window.pageYOffset && bottom < window.pageYOffset) &&
        !(
          top > window.pageYOffset + window.innerHeight &&
          bottom > window.pageYOffset + window.innerHeight
        )
      );
    },
    handleScroll() {
      this.check_scroll_for.find((identifier) => {
        let el = document.querySelector(identifier);
        if (el && this.elementInViewport(el)) {
          if (
            identifier === ".bench-players" &&
            !this.is_scrolled_till.bench_players
          ) {
            this.is_scrolled_till.bench_players = true;
            let toTrack = CFG_TRACKING["6"];
            toTrack.value = "";
            toTrack.label = "scroll till bench players";
            toTrack = addPagePropertiesToObject(toTrack);
            sendTrackingData(toTrack);
          }
          if (
            identifier === ".excluded-players" &&
            !this.is_scrolled_till.excluded_players
          ) {
            this.is_scrolled_till.excluded_players = true;
            let toTrack = CFG_TRACKING["6"];
            toTrack.value = "";
            toTrack.label = "scroll till excluded players";
            toTrack = addPagePropertiesToObject(toTrack);
            sendTrackingData(toTrack);
          }
        }
      });
    },
    /*
     */
    toggleTab(type) {
      if (
        (this.locked_players.length || this.out_players.length) &&
        type === "pitch"
      ) {
        this.show_loader = true;
        this.addCustomStrategyOption();
        this.$store.dispatch("team_store/fetchLineup").then(() => {
          this.show_loader = false;
          this.tab_view = type;
        });
      } else {
        let toTrack = CFG_TRACKING["15"];
        toTrack.value = "";
        toTrack.label = type === "list" ? "Edit Mode" : "View Mode";
        toTrack = addPagePropertiesToObject(toTrack);
        sendTrackingData(toTrack);
        this.tab_view = type;
      }
    },
    addCustomStrategyOption() {
      if (this.lineup_selection.s_id === 0) return;

      if (+this.lineup_selection.s_id === 1) {
        //incase of clicking autocomeplete while best fit is selected* change option to balanced and team index to 0
        this.custom_team_base_sid = 2;
      } else {
        this.custom_team_base_sid = +this.lineup_selection.s_id;
      }
      this.lineup_selection.s_id = 0;
      let stg_dropdown = deepClone(this.stg_dropdown);
      stg_dropdown[this.lineup_selection.p_id].push({
        name: "Custom",
        sid: 0,
        sn: "Custom",
        ssn: "Custom",
        teams: [],
      });
      this.stg_dropdown = stg_dropdown;
    },
    removeCustomStrategyOption() {
      this.custom_team_base_sid = null;
      let stg_dropdown = deepClone(this.stg_dropdown);
      stg_dropdown[this.lineup_selection.p_id] = stg_dropdown[
        this.lineup_selection.p_id
      ].filter((stg) => stg.sid !== 0);
      this.stg_dropdown = stg_dropdown;
    },
    ratingDisplayVal(val) {
      if (val === undefined || val === null || val.length === "") {
        return "-";
      }
      return val;
    },
  },
  beforeDestroy() {
    typeof window !== "undefined" &&
      document.removeEventListener("scroll", this.handleScroll);

    if (typeof document !== "undefined") {
      document.removeEventListener("click", this.closeToolTip);
      document.removeEventListener("touchstart", this.closeToolTip);
    }
  },
  mounted() {
    if (typeof document !== "undefined") {
      document.addEventListener("click", this.closeToolTip);
      document.addEventListener("touchstart", this.closeToolTip);
    }
  },
  watch: {
    error_status: function (to, from) {
      if (to) {
        setTimeout(this.closeToast, 2000);
      }
    },
  },
};
</script>
